import { useState } from "react";
import Input from "../custom-control/Input";
import Select from "../custom-control/Select";
import Accordion from "../custom-control/Accordion";
import styles from "./MyForm.module.scss";
import { isEmail } from "../util/validator";
import { Blocks } from "react-loader-spinner";
import {
  GENDER_LIST,
  ROLE_LIST,
  VISA_STATUS_LIST,
  LICENSE_STATUS_LIST,
  BUSINESS_TYPE_LIST,
  JOB_TITLE_LIST,
  GST_REGISTERED_LIST
} from "../util/constants";
import { insertAgent } from "../http";
import { useNavigate } from "react-router-dom";
import GoogleAddressInput from "../custom-control/GoogleAddressInput";
import header from "./header.jpg";
import footer from "./footer.jpg";
import MobileInput from "../custom-control/MobileInput";

//import axios from "axios";

export default function MyForm() {
  const [isLoading, setIsLoading] = useState(false);
  const [loadingText, setLoadingText] = useState("");
  const [serverError, setServerError] = useState("");
  const [succeedInfo, setSucceedInfo] = useState("");
  const [companyEmailIsInvalid, setCompanyEmailIsInvalid] = useState(false);
  const [personalEmailIsInvalid, setPersonalEmailIsInvalid] = useState(false);
  const [fields, setFields] = useState({});
  const [errors, setErrors] = useState([]);
  const navigate = useNavigate();

  // const changeHandler(field,value)=>{
  //   setErrors({
  //     ...errors,
  //     [field]:value?
  //   })
  // }
  function sumbitHandler(event) {
    console.log("submit button clicked");
    event.preventDefault();
    const fd = new FormData(event.target);
    const formData = Object.fromEntries(fd.entries());
    console.log(formData);
    const formErrors = [];
    let formIsValid = true;
    //validate the input here
    if (!formData["firstName"]) {
      formErrors["firstName"] = "First name is required";

      formIsValid = false;
    }
    if (!formData["lastName"]) {
      formErrors["lastName"] = "Last name is required";
      formIsValid = false;
    }
    if (!formData["companyEmail"]) {
      formErrors["companyEmail"] = "Company email is required";
      formIsValid = false;
    }

    // if (!formData["personalEmail"]) {
    //   formErrors["personalEmail"] = "Personal email is required";
    //   formIsValid = false;
    // }
    // if (!formData["addressLine1"]) {
    //   formErrors["addressLine1"] = "Street address is required";
    //   formIsValid = false;
    // }
    // if (!formData["suburb"]) {
    //   formErrors["suburb"] = "Suburb is required";
    //   formIsValid = false;
    // }
    // if (!formData["state"]) {
    //   formErrors["state"] = "State is required";
    //   formIsValid = false;
    // }
    // if (!formData["postcode"]) {
    //   formErrors["postcode"] = "Postcode is required";
    //   formIsValid = false;
    // }

    setErrors(formErrors);

    if (!formIsValid) {
      window.scrollTo(0, 0);
      return;
    }
    console.log("start calling webapi here...");

    setIsLoading(true);
    setLoadingText("saving data, please wait...");

 
      insertAgent(formData)
      .then((response) => {
        console.log("succeeded");
        setSucceedInfo("Succeeded!");
          navigate("completion");
      })
      .catch((error) => {
        setServerError(error.response.data);
        //window.scrollTo(0, 0);
        console.log(error);
      })
      .finally(() => {
        setIsLoading(false);
      });
 
   
  }
  function clearErrorHandler(id) {
    setErrors((prev) => {
      let errs = { ...prev };
      errs[id] = "";
      return errs;
    });
  }
  function setErrorHandler(id) {
    setErrors((prev) => {
      let errs = { ...prev };
      errs[id] = `${id} required`;
      return errs;
    });
  }

  function handleSubmit(event) {
    console.log("i am here");
  }
  function handleOnBlur(event) {
    console.log(event.target.value);
    const node = event.target;
    if (node.name === "companyEmail") {
      setCompanyEmailIsInvalid(!isEmail(node.value));
    }
    if (node.name === "personalEmail") {
      setPersonalEmailIsInvalid(!isEmail(node.value));
    }
  }

  if(isLoading)
    {
      return (
    <div className={styles.hvCenter} >  <Blocks
    height="80"
    width="80"
    color="#4fa94d"
    ariaLabel="blocks-loading"
    wrapperStyle={{}}
    wrapperClass="blocks-wrapper"
    visible={isLoading}/>
      <p>{loadingText}</p>
    
    </div>
  
    
  
  )}

  return (
    <>
      <div className={styles.page}>
        <img src={header} alt="logo" className={styles.headerImage} />

        <form
          id="form"
          name="form"
          className={styles.form}
          onSubmit={sumbitHandler}
        >
          {succeedInfo && <p>{succeedInfo}</p>}
          {serverError && (
            <div className="error">
              <div>Faile to save your data due to:</div>
              <div>{serverError}</div>
            </div>
          )}

          <Accordion label="Personal Info">
            <Input
              name="firstName"
              id="firstName"
              label="First Name"
              mandatory="true"
              error={errors["firstName"] ?? ""}
            />
            <Input
              name="middleName"
              id="middleName"
              label="Middle Name"
              type="text"
            />
            <Input
              name="lastName"
              id="lastName"
              label="Last Name"
              type="text"
              mandatory="true"
              error={errors["lastName"] ?? ""}
            />
            <Input
              name="preferredName"
              id="preferredName"
              label="Preferred Name"
              type="text"
              aria-label="preferred-name"
            />

            <Input
              type="date"
              name="dob"
              id="dob"
              aria-label="dob"
              label="Date Of Birth"
            />
            <Input
              name="companyEmail"
              id="companyEmail"
              label="Company Email"
              type="email"
              mandatory="true"
              onBlur={handleOnBlur}
              error={
                errors["companyEmail"]
                  ? errors["companyEmail"]
                  : companyEmailIsInvalid
                  ? "Invalid email address"
                  : ""
              }
            />
            <Input
              name="personalEmail"
              id="personalEmail"
              label="Personal Email"
              type="email"
              onBlur={handleOnBlur}
              error={personalEmailIsInvalid ? "Invalid email address" : ""}
            />
            <MobileInput
              name="Mobile"
              id="Mobile"
              type="text"
              label="Mobile"
              aria-label="mobile"
            />
            <GoogleAddressInput
              label="Street Address"
              mandatory={false}
              clearError={clearErrorHandler}
              setError={setErrorHandler}
              errors={errors}
            ></GoogleAddressInput>
            <Select
              name="visaStatus"
              id="visaStatus"
              label="Visa Status"
              simpleValues={VISA_STATUS_LIST}
            ></Select>
            <Input
              name="emergencyContact"
              id="emergencyContact"
              label="Emergency Contact"
              type="text"
            />
            <Input
              name="contactNumber"
              id="contactNumber"
              label="Contact Number"
              type="text"
              aria-label="contact-number"
            />
          </Accordion>
          <Accordion label="License & A/C">
            <Select
              name="jobTitle"
              id="jobTitle"
              label="Position"
              simpleValues={JOB_TITLE_LIST}
            ></Select>
            <Select
              name="licenseStatus"
              id="licenseStatus"
              label="License Status"
              simpleValues={LICENSE_STATUS_LIST}
            ></Select>
            <Input
              name="licenseNumber"
              id="licenseNumber"
              type="text"
              label="Certificate/License Number"
            />
             <Select
              name="businessType"
              id="businessType"
              label="Business Type"
              simpleValues={BUSINESS_TYPE_LIST}
            ></Select>
            <Input name="tfn" id="tfn" type="text" label="TFN" />
            <Input name="abn" id="abn" type="text" label="ABN" />
            <Input name="acn" id="acn" type="text" label="ACN" />
           
           
            <Select
              name="gstYn"
              id="gstYn"
              label="GST Registration"
              simpleValues={GST_REGISTERED_LIST}
            ></Select>

            <Input
              name="accountName"
              id="accountName"
              type="text"
              aria-label="account-name"
              label="Bank A/C Name"
            />
            <Input
              name="bsb"
              id="bsb"
              type="text"
              label="BSB"
              aria-label="bsb"
            />
            <Input
              name="accountNo"
              id="accountNo"
              type="text"
              label="A/C No"
              aria-label="bank-account-no"
            />
            <span className={styles.footNote}>
              I acknowledge that I am responsible to check and satisfy the
              related license & insurance regulation & requirements from the
              industry with ongoing basis.
            </span>

          </Accordion>

  

          <div className={styles.submitWrapper}>
            <button aria-label="submit-button" className={styles.submit}>
              SUBMIT
            </button>
          </div>
        </form>
        <img src={footer} alt="logo" className={styles.headerImage} />
      </div>
    </>
  );
}
